import React, { useMemo } from "react";
import "./GenOverView.css";
import { Grid } from "@mui/material";

import {
  Bar,
  ComposedChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import CustomizeTootip from "../../components/CustomizeTootip";

import GraphLoader from "../../components/GraphLoader";

const ACLineLoss = ({ loading, acLineLossActualPr }) => {
  const data = useMemo(() => {
    if (acLineLossActualPr?.length > 0) {
      return acLineLossActualPr?.reduce((acc, curr, index) => {
        if(curr?.["Ac Line Loss"]){
          acc.push({
            Date: curr["Date"],
            "AC Loss": curr["Ac Line Loss"],
          });
        }
       
        return acc;
      }, []);
    }
    return [];
  }, [acLineLossActualPr]);
  return loading ? (
    <Grid
      item
      // lg={3.5}
      // md={6}
      // sm={6}
      // xs={12}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#fff",
        minHeight:"30vh"
      }}
    >
      <GraphLoader />
    </Grid>
  ) : !acLineLossActualPr || data?.length == 0 ? (
    <Grid
      item
      // lg={3.5}
      // md={6}
      // sm={6}
      // xs={12}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#fff",
        minHeight:"30vh"
      }}
      
    >
      <div style={{ width: "100%", fontSize: "2vmin" }}>
        <p>Ac Line Loss</p>
        <p>Data Not Available</p>
      </div>
    </Grid>
  ) : (
    
      <Grid
       item
        // lg={3.5} md={6} sm={6} xs={12}
         className="gen-overview-3"
         >
        <span>AC Line Loss (%)</span>
        <ResponsiveContainer width={"100%"} >
          <ComposedChart
            title="Ac Line Loss"
            margin={{
              top: 5,
              bottom: 0,
              left: 5,
              right: 5,
            }}
            data={data || []}
          >
            <XAxis
              axisLine={false}
              dataKey="Date"
              // interval={0}
              fontSize={"0.6rem"}
              tickMargin={8}
              fontWeight={600}
              tickLine={false}
              angle={false}
              padding={{ right: 5 }}
            />
            <YAxis
              hide
              tickLine={false}
              angle={false}
              // domain={[
              //   Math.floor(
              //     data?.reduce(
              //       (acc, curr, index) =>curr["Ac Loss"]? Math.min(curr["Ac Loss"], acc):acc,
              //       Infinity
              //     )
              //   ),
              //   Math.ceil(
              //     data?.reduce(
              //       (acc, curr, index) =>curr['Ac Loss']? Math.max(curr["Ac Loss"], acc):acc,
              //       -Infinity
              //     )
              //   ),
              // ]}
            />
            <Tooltip
              cursor={{ fill: "none" }}
              content={
                <CustomizeTootip
                  active={false}
                  payload={[]}
                  label={""}
                  TooltipValues={["AC Loss"]}
                />
              }
            />
            <Bar
              barSize={12}
              radius={18}
              dataKey="AC Loss"
              fill="rgb(61, 74, 138)"
            ></Bar>
          </ComposedChart>
        </ResponsiveContainer>
      </Grid>
    
  );
};

export default ACLineLoss;
